import { GraphQLResult } from '@aws-amplify/api';
import {
  CreateVendorInput, CreateVendorMutation, SearchVendorsQuery, Vendor, VendorType,
} from 'API';
import { createVendor } from 'graphql/mutations';
import { searchVendors } from 'graphql/queries';
import { client } from 'lib/graphql-client';
import { DICTIONARY } from 'shared/constants';
import { lower, notNullFilter } from 'shared/utilities';

class VendorService {
  create = async (input: CreateVendorInput) => {
    try {
      const response = await client.graphql({
        query: createVendor,
        variables: { input },
      }) as GraphQLResult<CreateVendorMutation>;

      return (response.data?.createVendor as Vendor) || null;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      throw new Error(DICTIONARY.VendorCreateFailed);
    }
  };

  searchByName = async (name: string, type: VendorType, maxCount = 20) => {
    if (!name) {
      return [];
    }

    const chunks = lower(name).split(' ').filter(Boolean);
    const andArray: Array<Record<string, unknown>> = [{ type: { eq: type } }];

    chunks.forEach((chunk) => {
      andArray.push({ name: { wildcard: `*${chunk}*` } });
    });

    try {
      const response = await client.graphql({
        query: searchVendors,
        variables: {
          filter: { and: andArray },
          limit: maxCount,
        },
      }) as GraphQLResult<SearchVendorsQuery>;

      return response.data?.searchVendors?.items?.filter(notNullFilter) || [];
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
      throw new Error(DICTIONARY.VendorSearchFailed);
    }
  };
}

export default new VendorService();
